/* eslint-disable no-mixed-spaces-and-tabs */
import { darken, lighten, makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  resultTable: {
    margin: '10px 25px 25px 25px !important'
  },
  resultHeader: {
    backgroundColor: theme.palette.header,
    color: theme.palette.amano.base.main,
  },
  lpWrapper: {
    marginLeft: 'auto',
  },
  iconText:{
    marginLeft: '10px',
    textAlign:"center",
    borderRadius: 3,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.light,
    padding:"4px 6px 4px 6px",
		fontFamily: `"Lucida Console","Courier New","monospace"`,
  },
  name: {
    alignSelf: 'center'
  },
  ageWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      marginLeft: 0,
    },
    marginLeft: 5,
    color: theme.palette.amano.base.secondary.main,
  },
  clickableRow: {
    cursor: 'pointer'
  },
	confidence: {
		float: 'right'
	},
	credentialFlex: {
		display: "flex",
		justifyContent: "space-between",
		flexWrap: "wrap"
	}
}));